// @flow
import * as React from 'react'
import { useSelector } from 'react-redux'
import { config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { DriveToDownloadModule } from '@components/DriveToDownloadModule'
import { GoodSansB2, QueensH3 } from '@components/shared'
import { colors } from '@components/shared/colors'
import SubscribeCta from '@components/SubscribeCta'
import type { AppStateType } from '../reducers/appstate'
import { useSearchParams } from 'next/navigation'

export function BenefitsSection (props: { ctaText?: string }): React.Node {
  const isSubscribed = useSelector((state: AppStateType): boolean => !!(state.user || {}).isSubscribed)
  const searchParams = useSearchParams()
  if (searchParams.get('b') !== '1') {
    return null
  }
  if (isSubscribed) return null

  return (
    <DriveToDownloadModule isFullBleed>
      <Header>Try Dipsea For Free</Header>
      <List>
        <Check><li>1000+ spicy audiobooks & romance novels</li></Check>
        <Check><li>New chapters every week</li></Check>
        <Check><li>Your favorite tropes & irresistible new characters</li></Check>
        <Check><li>High-quality stories brought to life</li></Check>
        <Check><li>Cancel anytime</li></Check>
      </List>
      <ButtonWrapper>
        <SubscribeCta ctaText={props.ctaText}/>
      </ButtonWrapper>
    </DriveToDownloadModule>
  )
}

const Header = styled.h1`
  ${QueensH3};
  color: ${colors.sand};
  margin-bottom: 1rem;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    text-align: left;
  `};
`
const List = styled.ul`
  ${GoodSansB2};
  align-self: center;
  color: ${colors.sand};
  list-style: none;
  margin-bottom: 1.5rem;
  padding: 0;
  li {
    margin-left: 8px;
  }
  ${(props: any): string => config(props).media.md`
    align-self: flex-start;
    margin-left: 10px;
  `};
`

const Check = styled.div`
  display: flex;
  :before {
    content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOSAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy45MTU2IDAuNzMxMDA2QzE4LjQ0NzYgMS4xMTY1NyAxOC41NTg1IDEuODQ5OSAxOC4xNjMzIDIuMzY4OTNMNy43NjMzMSAxNi4wMjc0QzcuNTQ2OTYgMTYuMzExNSA3LjIxMDQ3IDE2LjQ4NDkgNi44NDc5NSAxNi40OTkxQzYuNDg1NDQgMTYuNTEzMiA2LjEzNTgzIDE2LjM2NjYgNS44OTY5MiAxNi4xMDAyTDAuMjk2OTI0IDkuODU2MzNDLTAuMTM5NDk0IDkuMzY5NzMgLTAuMDg4OTUzMSA4LjYzMDExIDAuNDA5ODExIDguMjA0MzRDMC45MDg1NzUgNy43Nzg1NyAxLjY2NjY5IDcuODI3ODcgMi4xMDMxMSA4LjMxNDQ3TDYuNzIzNjcgMTMuNDY2M0wxNi4yMzY3IDAuOTcyNjY3QzE2LjYzMTkgMC40NTM2MzQgMTcuMzgzNiAwLjM0NTQzOCAxNy45MTU2IDAuNzMxMDA2WiIgZmlsbD0iI0UzRDBDNSIvPgo8L3N2Zz4K');
    transform: scale(.8);
    ${(props: any): string => config(props).media.lg`
      transform: scale(1);
    `};
  }
`

const ButtonWrapper = styled.div`
  margin-bottom: 2rem;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    text-align: left;
  `};
`
